import { Button } from 'antd'
import { history } from '../../redux/store'
import Style from './not.module.scss'
// 404 page
const Notfound = () => {
  function onhandlegoback() {
    history.replace('/login')
  }
  return (
    <div className={Style.resultbox}>
      <div className={Style.resultimg}>
        <img
          src="https://test-xhgj-xhmall-product.oss-cn-shanghai.aliyuncs.com/ui-common-imgs/img_404.png"
          alt="404"
        />
      </div>
      <div className={Style.resulttitle}>404</div>
      <div className={Style.resultsubtitle}>抱歉, 您访问的页面不存在.</div>
      <div className={Style.resultextra}>
        <Button type="primary" onClick={onhandlegoback}>
          返回登录页
        </Button>
      </div>
    </div>
  )
}

export default Notfound
import { Button } from 'antd'
import { history } from '../../redux/store'
import Style from './not.module.scss'
// 404 page
const Notfound = () => {
  function onhandlegoback() {
    history.replace('/login')
  }
  return (
    <div className={Style.resultbox}>
      <div className={Style.resultimg}>
        <img
          src="https://test-xhgj-xhmall-product.oss-cn-shanghai.aliyuncs.com/ui-common-imgs/img_404.png"
          alt="404"
        />
      </div>
      <div className={Style.resulttitle}>404</div>
      <div className={Style.resultsubtitle}>抱歉, 您访问的页面不存在.</div>
      <div className={Style.resultextra}>
        <Button type="primary" onClick={onhandlegoback}>
          返回登录页
        </Button>
      </div>
    </div>
  )
}

export default Notfound
